import { render, staticRenderFns } from "./StudentRegister.vue?vue&type=template&id=dd9bb636&scoped=true&"
import script from "./StudentRegister.vue?vue&type=script&lang=ts&"
export * from "./StudentRegister.vue?vue&type=script&lang=ts&"
import style0 from "./StudentRegister.vue?vue&type=style&index=0&id=dd9bb636&lang=scss&scoped=true&"
import style1 from "./StudentRegister.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9bb636",
  null
  
)

export default component.exports